import { useCallback } from 'react';

import { PlayerAPI } from 'bitmovin-player/modules/bitmovinplayer-core';

import {
    PlayerTrack,
    PlayerTrackEncodeType,
    PlayerTracks,
} from 'store/player/reducer.types.ts';

import { translateCodecToEncodingType } from '../../utils.ts';

type Params = {
    player: PlayerAPI | null;
    onTracksChanged?: (tracks: PlayerTracks) => void;
};

function useAudioSubtitlesChange({ player, onTracksChanged }: Params) {
    const handleAudioSubtitlesChange = useCallback(() => {
        const playerTracks: PlayerTracks = {
            audioTracks: [],
            textTracks: [],
        };
        const availableAudio = player?.getAvailableAudio();
        const availableSubtitles = player?.subtitles.list();

        availableAudio?.forEach((_audio) => {
            const [quality] = _audio.getQualities?.() || [];

            playerTracks.audioTracks.push({
                id: _audio.id,
                title: _audio.label,
                language: _audio.lang,
                encodeType: translateCodecToEncodingType(quality?.codec),
                characteristics: [],
                channelCount: quality?.channels as PlayerTrack['channelCount'],
            });
        });

        availableSubtitles?.forEach((_subtitle) => {
            // Exclude "caption" from the subtitle list.
            if (
                _subtitle.kind === 'subtitles' ||
                _subtitle.kind === 'subtitle'
            ) {
                playerTracks.textTracks.push({
                    id: _subtitle.id,
                    title: _subtitle.label,
                    language: _subtitle.lang,
                    encodeType: PlayerTrackEncodeType.UNKNOWN,
                    characteristics: [],
                });
            }
        });

        onTracksChanged?.(playerTracks);
    }, [onTracksChanged, player]);

    return { handleAudioSubtitlesChange };
}

export default useAudioSubtitlesChange;
